(() => {
  const arrangeProductExtras = () => {
    const footer = document.querySelector('.section-roshi-footer');
    if (!footer) return;

    const extras = document.querySelectorAll(
      '.section-mwkeys-product-details, .section-roshi-product-reviews'
    );

    extras.forEach((extra) => {
      const hasVisibleModule = extra.querySelector(
        '.mwkeys-product-details-editor, .roshi-product-reviews'
      );

      if (!hasVisibleModule) {
        extra.hidden = true;
        return;
      }

      extra.hidden = false;
      footer.before(extra);
    });
  };

  arrangeProductExtras();
  document.addEventListener('shopify:section:load', arrangeProductExtras);
  document.addEventListener('shopify:section:reorder', arrangeProductExtras);
})();
